import { render, staticRenderFns } from "./MultipleLanguageSection.vue?vue&type=template&id=b3481076&scoped=true&"
import script from "./MultipleLanguageSection.vue?vue&type=script&lang=js&"
export * from "./MultipleLanguageSection.vue?vue&type=script&lang=js&"
import style0 from "./MultipleLanguageSection.vue?vue&type=style&index=0&id=b3481076&prod&lang=css&"
import style1 from "./MultipleLanguageSection.vue?vue&type=style&index=1&id=b3481076&prod&lang=css&"
import style2 from "./MultipleLanguageSection.vue?vue&type=style&index=2&id=b3481076&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3481076",
  null
  
)

export default component.exports